import styled from 'styled-components';

const menuHeight = '53px';
const menuBtnSize = '50px';
const menuBtnSizeReduced = '45px';
const topMarginHeight = '40px';
const percentageSize = 1.3;

export const LlegendaContainer = styled.div`
  background: transparent;
  display: block;
  position: absolute;
  z-index: 1;
  align-items: center;
  top: ${({ displayNav }) => (displayNav ? topMarginHeight : '0px')};
  left: 0;
  padding: 10px;

  @media screen and (max-width: 768px) {
    margin-top: 40px;
  }
`;

export const LlegendaWrapper = styled.div``;

export const LlegendaBtnWrapper = styled.div`
  display: ${({ selected }) => (selected ? 'flex' : 'none')};
  text-align: center;
  height: 60px;
  width: 100%;
  padding: 2px;
`;

export const LlegendaBtnIcon = styled.div`
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  display: flex;
  justify-content: center;
  vertical-align: middle;
  align-items: center;
  border: 0;
  width: ${menuBtnSizeReduced};
  cursor: ${({ editing }) => (editing ? 'default' : 'pointer')};
  z-index: 2;
  /* cursor: pointer; */
  background-color: ${({ isOpen }) => (isOpen ? '#febf00' : '#666666')};

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }
`;

export const LlegendaBtnIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  filter: ${({ isOpen }) => (isOpen ? 'none' : 'brightness(0) invert(1)')};
  opacity: 100%;
`;

export const LlegendaBtnNotification = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  background: ${({ editing }) => (editing ? '#c00000' : '#c00000')};
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

export const LlegendaMenuWrapper = styled.div`
  display: ${({ open }) => (open ? 'flex' : 'none')};
  max-height: ${(props) => (props.alturaInfoPunt ? window.innerHeight - 180 - props.alturaInfoPunt + 'px' : window.innerHeight - 150 + 'px')};
  align-items: center;
  flex-flow: column;
  justify-content: flex-start;
  position: fixed;
  top: ${({ displayNav }) => (displayNav ? menuHeight : '15px')};
  border-radius: 5px;
  left: 12px;
  padding-left: 10px;
  padding-right: 1px;
  overflow: hidden;
  border-top-left-radius: 30px;
  background-color: rgba(51, 51, 51, 0.85);
  z-index: 1;
  padding-top: calc(${menuBtnSize} + 8px);
  overscroll-behavior: contain;
  color: #fff;
  width: 375px;

  ::-webkit-scrollbar {
    background-color: transparent;
    display: block;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 1em;
    margin: 15px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
    direction: ltr;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
    direction: ltr;
  }

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    top: 95px;
    border-top-left-radius: 25px;
  }

  //mobile
  @media screen and (max-width: 464px) {
    max-height: ${(props) => window.innerHeight - 130 - (props.alturaInfoPunt + 100) + 'px'};
    width: calc(97% - 12px);
    border-top-left-radius: 25px;
  }
`;

export const CapesLlegendaWrapper = styled.div`
  overflow-y: scroll;
  /* padding-right: 5px; */
  width: 100%;

  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
    align-items: left;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
  @media screen and (max-width: 464px) {
    width: 100%;
  }
  @media screen and (max-width: 390px) {
    width: 100%;
  }
`;
